import { useEffect, useState } from 'react';
import useCurrentBreakpoint from '../../../hooks/useCurrentBreakpoint';

type SliderProperties = {
    slidesToShow: number;
    slidesToScroll: number;
}

const useSliderProperties = (): SliderProperties => {
  const { currentBreakpoint } = useCurrentBreakpoint();
  const [slidesToShow, setSlidesToShow] = useState(3);
  const [slidesToScroll, setSlidesToScroll] = useState(3);
  const lookup = {
    xxs: 1,
    xs: 1,
    sm: 2,
    md: 2,
    lg: 3,
    xl: 3,
  };
  useEffect(() => {
    setSlidesToScroll(lookup[currentBreakpoint as keyof typeof lookup]);
    setSlidesToShow(lookup[currentBreakpoint as keyof typeof lookup]);
  }, [currentBreakpoint]);
  return { slidesToShow, slidesToScroll };
};

export default useSliderProperties;
